import styled from 'styled-components'

export const GlobalStyle = styled.div`
`
